/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-05-28 13:59:38
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-06-16 11:32:49
 */

import * as request from '@/utils/request'

export default {
  /**
   * getBillList
   * @description 合同列表
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getAdminBillList(data) {
    return request.post('/admin_bill/list', data)
  },
  /**
   * saveBill
   * @description 保存合同
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  saveAdminBillAudit(data) {
    return request.post('/admin_bill/audit', data)
  },
  /**
   * deleteBill
   * @description 删除合同
   * @author YQ
   * @date 2019-01-19
   * @param {*} id
   * @returns
   */
  deleteAdminBill(id) {
    let data = {id:id}
    return request.post('/admin_bill/delete', data)
  },
}